import store from './../store';
import {
  MODAL_FIX_CLOSE,
  MODAL_FIX_MARK_CURRENT_STEP_FOR_REMOVAL,
  MODAL_FIX_NEXT_STEP,
  MODAL_FIX_OPEN,
  MODAL_FIX_PREV_STEP,
  MODAL_FIX_SET_NEXT_DISABLED_FOR_CURRENT_STEP,
  MODAL_FIX_SKIP_STEP,
  MODAL_FIX_TRIGGER_NEXT, MODAL_FIX_UPDATE_FEATURE_ID,
} from "./actionTypes";
import {
  restoreFromSnapshot
} from "../bvcomponents/sqft/components/popup/modalFix/CompatibilityWarnings/modalFixHelper";
import {enableSquareFootage, setSqftFromFeature, setSQFTInVisualizer} from "./sqftFunctions";
import {setSqftOpenedFromFeature} from "./selectionFunctions";
import {setWizardConflictSteps} from "./wizardFunctions";
import sqftConfig from "../bvcomponents/sqft/components/canvas/store/sqftConfig";
import * as types from "./actionTypes";
import {isModalFixEnabled} from "../bvcomponents/sqft/components/popup/modalFix/modalFixConfig";

// We are creating snapshot before feature was changed
export const openModalFix = (id, steps, onComplete = null) => (dispatch) => {
  if (!isModalFixEnabled()) {
    return;
  }

  const state = store.getState();
  const isSquareFootageEnabledOnOpen = !!state.sqftState?.isSquareFootageEnabled;

  dispatch({
    type: MODAL_FIX_OPEN,
    payload: { id, steps, isSquareFootageEnabledOnOpen, onComplete }
  });

  // Call onStepEnter callback for first step
  const firstStepData = steps[0];
  if (firstStepData?.onStepEnter && typeof firstStepData.onStepEnter === 'function') {
    firstStepData.onStepEnter(firstStepData, dispatch);
  }
};

export const closeModalFix = (shouldRestore = true) => async (dispatch) => {

  const state = store.getState();
  const { sqftModalFixState } = state;

  // Restore from snapshot only when canceling (not when finishing)
  if (shouldRestore && sqftModalFixState.snapshot) {
    await restoreFromSnapshot(sqftModalFixState.snapshot);
  }

  // Call onStepExit callback for current step
  if (sqftModalFixState.isModalFixOpen && sqftModalFixState.steps.length > 0) {
    const currentStepData = sqftModalFixState.steps[sqftModalFixState.currentStep - 1];
    if (currentStepData && currentStepData.onStepExit && typeof currentStepData.onStepExit === 'function') {
      currentStepData.onStepExit(currentStepData, dispatch);
    }
  }

  //close or open sqft
  const isSquareFootageEnabledOnOpen = !!sqftModalFixState.isSquareFootageEnabledOnOpen;

  if (isSquareFootageEnabledOnOpen
    && !state.wizardState.wizardConflictingSteps.length
    && state.sqftState.sqftFromFeature?.cartFeature) {
    // no more conflicts left, we need to make sure newly created sqft shapes should be with updated wizard value
    const newSelectedKey = Object.keys(state.wizardState.wizardSelectedValues).find(key => {
      return (state.wizardState.wizardSelectedValues[key]?.selectedFeature?.partId === state.sqftState.sqftFromFeature.cartFeature.partId)
    });
    if (newSelectedKey) {
      const newSelectedFeature = state.wizardState.wizardSelectedValues[newSelectedKey]?.selectedFeature;
      dispatch(setSqftFromFeature({cartFeature: newSelectedFeature}));
      dispatch(setSqftOpenedFromFeature(newSelectedFeature));
    }
  }

  dispatch(enableSquareFootage(isSquareFootageEnabledOnOpen));
  dispatch(setSQFTInVisualizer(false));
  dispatch(setWizardConflictSteps([]));
  sqftConfig.initializeDependentProperties();

  dispatch({ type: MODAL_FIX_CLOSE });
};

export const nextStepModalFix = () => (dispatch) => {
  const state = store.getState();
  const { sqftModalFixState } = state;

  if (sqftModalFixState.currentStep < sqftModalFixState.totalSteps) {
    // Call onStepExit callback for current step if it exists
    const currentStepData = sqftModalFixState.steps[sqftModalFixState.currentStep - 1];
    if (currentStepData && currentStepData.onStepExit && typeof currentStepData.onStepExit === 'function') {
      currentStepData.onStepExit(currentStepData, dispatch);
    }

    dispatch({ type: MODAL_FIX_NEXT_STEP });

    // Get updated state after step change
    const newState = store.getState();
    const { sqftModalFixState: updatedSqftModalFixState } = newState;
    const nextStepData = updatedSqftModalFixState.steps[updatedSqftModalFixState.currentStep - 1];

    // Call onStepEnter callback for new step if it exists
    if (nextStepData && nextStepData.onStepEnter && typeof nextStepData.onStepEnter === 'function') {
      nextStepData.onStepEnter(nextStepData, dispatch);
    }
  } else {
    // Last step completed
    const currentStepData = sqftModalFixState.steps[sqftModalFixState.currentStep - 1];
    if (currentStepData && currentStepData.onStepExit && typeof currentStepData.onStepExit === 'function') {
      currentStepData.onStepExit(currentStepData, dispatch);
    }

    dispatch({ type: MODAL_FIX_NEXT_STEP });
  }
};

export const prevStepModalFix = () => (dispatch) => {
  const state = store.getState();
  const { sqftModalFixState } = state;

  if (sqftModalFixState.currentStep > 1) {
    // Call onStepExit callback for current step if it exists
    const currentStepData = sqftModalFixState.steps[sqftModalFixState.currentStep - 1];
    if (currentStepData && currentStepData.onStepExit && typeof currentStepData.onStepExit === 'function') {
      currentStepData.onStepExit(currentStepData, dispatch);
    }

    dispatch({ type: MODAL_FIX_PREV_STEP });

    // Get updated state after step change
    const newState = store.getState();
    const { sqftModalFixState: updatedSqftModalFixState } = newState;
    const prevStepData = updatedSqftModalFixState.steps[updatedSqftModalFixState.currentStep - 1];

    // Call onStepEnter callback for previous step if it exists
    if (prevStepData && prevStepData.onStepEnter && typeof prevStepData.onStepEnter === 'function') {
      prevStepData.onStepEnter(prevStepData, dispatch);
    }
  }
};

export const skipStepModalFix = () => (dispatch) => {
  const state = store.getState();
  const { sqftModalFixState } = state;

  // Call onStepExit callback for current step if it exists
  const currentStepData = sqftModalFixState.steps[sqftModalFixState.currentStep - 1];
  if (currentStepData && currentStepData.onStepExit && typeof currentStepData.onStepExit === 'function') {
    currentStepData.onStepExit(currentStepData, dispatch);
  }

  dispatch({ type: MODAL_FIX_SKIP_STEP });

  const newState = store.getState();
  const { sqftModalFixState: updatedSqftModalFixState } = newState;
  const nextStepData = updatedSqftModalFixState.steps[updatedSqftModalFixState.currentStep - 1];

  if (nextStepData && nextStepData.onStepEnter && typeof nextStepData.onStepEnter === 'function') {
    nextStepData.onStepEnter(nextStepData, dispatch);
  }
};

export const markCurrentStepForRemovalModalFix = (shouldRemove = true) => ({
  type: MODAL_FIX_MARK_CURRENT_STEP_FOR_REMOVAL,
  payload: { shouldRemove }
});

export const triggerNextStepModalFix = () => (dispatch) => {
  const state = store.getState();
  const { sqftModalFixState } = state;

  if (sqftModalFixState.isModalFixOpen && sqftModalFixState.showNext) {
    // Call onStepExit callback for current step if it exists
    const currentStepData = sqftModalFixState.steps[sqftModalFixState.currentStep - 1];
    if (currentStepData && currentStepData.onStepExit && typeof currentStepData.onStepExit === 'function') {
      currentStepData.onStepExit(currentStepData, dispatch);
    }

    dispatch({ type: MODAL_FIX_TRIGGER_NEXT });

    // Get updated state after step change
    const newState = store.getState();
    const { sqftModalFixState: updatedSqftModalFixState } = newState;

    if (updatedSqftModalFixState.currentStep <= updatedSqftModalFixState.totalSteps) {
      const nextStepData = updatedSqftModalFixState.steps[updatedSqftModalFixState.currentStep - 1];

      // Call onStepEnter callback for new step if it exists
      if (nextStepData && nextStepData.onStepEnter && typeof nextStepData.onStepEnter === 'function') {
        nextStepData.onStepEnter(nextStepData, dispatch);
      }
    }
  }
};
export const updateFeatureIdModalFix = (featureId, featureName = null) => (dispatch) => {
  dispatch({
    type: MODAL_FIX_UPDATE_FEATURE_ID,
    payload: { featureId, featureName }
  });
};

export const storeSnapshot = (snapshot) => ({
  type: types.STORE_SNAPSHOT,
  payload: {snapshot}
});

export const setNextDisabledForCurrentStepModalFix = (isDisabled) => (dispatch) => {
  dispatch({
    type: MODAL_FIX_SET_NEXT_DISABLED_FOR_CURRENT_STEP,
    payload: { isDisabled }
  });
};
